import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "output"]
  static values = {
    multiplier: { type: Number, default: 1 },
    format: { type: String, default: "currency" }
  }

  compute() {
    const raw = parseInt(this.inputTarget.value) || 0
    const result = raw * this.multiplierValue
    this.outputTarget.textContent = this.formatValue === "currency"
      ? `$${result.toFixed(2)}`
      : result.toString()
  }
}
